var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.billingRows.length)?_c('pending-billing-table',{attrs:{"rows":_vm.billingRows,"invoice-type":"AGENCY_TO_CLIENT"},on:{"rows-selected":_vm.onRowsSelected}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }